// extracted by mini-css-extract-plugin
export var attachmentContainer = "_np-0";
export var fileList = "_np-2";
export var removeFileButton = "_np-1";